export const en = {
  // Header
  announcement: "FREE SHIPPING ON ORDERS OVER €90 | AUTHENTIC LUXURY FRAGRANCES",
  shopAll: "SHOP ALL",
  perfumes: "PERFUMES",
  mensFragrances: "MEN",
  womensFragrances: "WOMEN",
  dubaiFragrances: "DUBAI FRAGRANCES",
  dubaiFragrancesSubtitle: "Discover exotic oriental fragrances from the most prestigious Arabian perfume houses",
  searchPlaceholder: "Search fragrances, brands...",
  searchInBrand: "Search within brand...",
  myProfile: "My Profile",
  adminPanel: "Admin Panel",
  logout: "Logout",

  // Smart Search
  suggestedBrands: "SUGGESTED BRANDS",
  suggestedProducts: "SUGGESTED PRODUCTS",
  productsFrom: "Products from",
  viewAllFromBrand: "View all",
  noSearchResults: "No results found",

  // Home / Hero
  heroTitle: "SELECTION OF LUXURY FRAGRANCES",
  heroSubtitle: "Discover exclusive perfumes from the world's most prestigious brands",
  heroButton: "EXPLORE COLLECTION",
  newArrivals: "NEW ARRIVALS",
  bestSellers: "BEST SELLERS",
  viewAllProducts: "VIEW ALL FRAGRANCES",
  shopByCategory: "SHOP BY CATEGORY",
  productsCount: "products",
  productSingular: "product",
  other: "Other",
  trustAuthentic: "100% AUTHENTIC",
  trustAuthenticDesc: "Sourced through established distribution channels",
  trustShipping: "FAST SHIPPING",
  trustShippingDesc: "Orders shipped within 1-2 business days",
  trustPayments: "SECURE PAYMENTS",
  trustPaymentsDesc: "Industry-standard encryption",
  shopNow: "Shop Now",

  // Products page
  allProducts: "All Fragrances",
  discoverCollection: "Discover our collection of luxury fragrances",
  discoverCollectionSingular: "Discover our collection of luxury fragrances",
  filters: "Filters",
  category: "Category",
  allProductsFilter: "All Products",
  brand: "Brand",
  allBrands: "All Brands",
  clearAllFilters: "Clear All Filters",
  clearFilters: "Clear Filters",
  showResults: "Show {count} products",
  clearAll: "Clear All",
  clearBrands: "Clear brands",
  gender: "Gender",
  all: "All",
  allGenders: "All",
  women: "Women",
  men: "Men",
  forWomen: "For Women",
  forMen: "For Men",
  targetAudience: "Target Audience",
  genderHint: "Select both for unisex products",
  
  // Scent Profiles Filter
  scentProfile: "Scent Profile",
  scentProfiles: "Scent Profiles",
  allScentProfiles: "All Profiles",
  withScentProfile: "With Profile",
  withoutScentProfile: "Without Profile",
  scentProfilesHint: "Select up to 4 scent profiles for this product",
  clearScentProfiles: "Clear profiles",
  scentSweet: "Sweet",
  scentFresh: "Fresh",
  scentCitrus: "Citrus",
  scentFruity: "Fruity",
  scentFloral: "Floral",
  scentWoody: "Woody",
  scentSpicy: "Spicy",
  scentAquatic: "Aquatic",
  scentMusky: "Musky",
  scentLeather: "Leather",
  scentTobacco: "Tobacco",
  scentOriental: "Oriental",
  scentVanilla: "Vanilla",
  scentAnalysis: "Scents",
  
  applyFilters: "Apply Filters",
  showingProducts: "Showing {count} products",
  sortBy: "Sort by:",
  sortPopular: "Popular",
  sortNewest: "Newest",
  sortName: "Name (A-Z)",
  sortPriceLow: "Price: Low to High",
  sortPriceHigh: "Price: High to Low",
  loadingProducts: "Loading products...",
  noProductsFound: "No products found matching your filters.",

  // Product Detail
  back: "Back",
  inStock: "In Stock",
  onlyLeft: "Only {count} left",
  outOfStock: "Out of Stock",
  freeReturnInfo: "14-day free returns",
  addToCart: "Add to Cart",
  addedToCart: "Added {qty} {name} to cart!",
  availableSizes: "Available sizes:",
  youMayAlsoLike: "You May Also Like",
  categoryLabel: "Category:",
  brandLabel: "Brand:",
  skuLabel: "SKU:",
  productNotFound: "Product not found",
  quickAdd: "QUICK ADD",

  // Cart
  shoppingCart: "Shopping Cart",
  cartEmpty: "Your cart is empty",
  cartEmptyDesc: "Looks like you haven't added any items to your cart yet.",
  startShopping: "Start Shopping",
  product: "Product",
  price: "Price",
  quantity: "Quantity",
  total: "Total",
  remove: "Remove",
  clearCartBtn: "Clear Cart",
  clearCartConfirm: "Are you sure you want to clear your cart?",
  orderSummary: "Order Summary",
  subtotal: "Subtotal",
  shipping: "Shipping",
  calculatedAtCheckout: "Calculated at checkout",
  freeShipping: "FREE",
  freeShippingNote: "Free shipping on orders over \u20ac90",
  addMoreForFree: "Add \u20ac{amount} more for free shipping!",
  shippingCost: "Standard Shipping",
  orderTotal: "Order Total",
  proceedToCheckout: "Proceed to Checkout",
  processingPayment: "Processing...",
  continueShopping: "Continue Shopping",
  items: "items",
  secureCheckout: "Cash on delivery or secure card payment",

  // Auth
  welcomeBack: "Welcome Back",
  createAccount: "Create Account",
  signInAccess: "Sign in to access your account",
  joinUs: "Join us to start shopping luxury cosmetics",
  fullName: "Full Name",
  email: "Email",
  password: "Password",
  signIn: "Sign In",
  signUp: "Sign Up",
  pleaseWait: "Please wait...",
  noAccount: "Don't have an account?",
  haveAccount: "Already have an account?",
  agreeTerms: "I agree to the",
  privacyPolicy: "Privacy Policy",
  and: "and",
  termsOfService: "Terms of Service",
  cookiePolicy: "Cookie Policy",
  newsletterOptIn: "I want to receive news, offers and promotions via email",
  fillAllFields: "Please fill in all fields",
  agreeTermsError: "Please agree to the Privacy Policy and Terms of Service",
  demoCredentials: "Demo credentials:",
  admin: "Admin:",

  // Profile
  profileTitle: "MY ACCOUNT",
  profileSubtitle: "Manage your account information, view order history, and manage shipping addresses",
  profileTab: "Profile",
  ordersTab: "Orders",
  collectionsTab: "Collections",
  homepageTab: "Homepage",
  discountsTab: "Discounts",
  addressesTab: "Addresses",
  accountInfo: "Account Information",
  personalInfo: "Personal Information",
  name: "Name",
  fullNameLabel: "Full Name",
  phone: "Phone",
  role: "Role",
  administrator: "Administrator",
  memberSince: "Member Since",
  orderHistory: "Order History",
  noOrders: "No orders yet. Start shopping to see your order history here.",
  trackingNumber: "Tracking Number",
  trackShipment: "Track Shipment",
  savedAddresses: "Saved Addresses",
  myAddresses: "My Addresses",
  addAddress: "Add Address",
  addNewAddress: "Add New Address",
  addFirstAddress: "Add Your First Address",
  noAddressesSaved: "No addresses saved yet",
  editAddress: "Edit Address",
  defaultAddress: "Default",
  setAsDefault: "Set as Default",
  addressLabel: "Label",
  labelPlaceholder: "Home, Work, etc.",
  street: "Street Address",
  streetPlaceholder: "123 Beauty Lane",
  city: "City",
  cityPlaceholder: "Brussels",
  postalCode: "Postal Code",
  postalCodePlaceholder: "1000",
  country: "Country",
  selectCountry: "Select Country",
  save: "Save",
  saveAddress: "Save Address",
  cancel: "Cancel",
  deleteAddress: "Are you sure you want to delete this address?",

  // Admin
  adminTitle: "Admin Panel",
  manageProducts: "Manage products and inventory ({count} products)",
  addProduct: "Add Product",
  createNewProduct: "Create New Product",
  editProduct: "Edit Product",
  productName: "Product Name",
  priceEur: "Price (\u20ac)",
  stock: "Stock",
  imageUrl: "Image URL",
  description: "Description",
  createProductBtn: "Create Product",
  saveChanges: "Save Changes",
  saving: "Saving...",
  noProductsYet: "No products yet. Click \"Add Product\" to create your first product.",
  image: "Image",
  actions: "Actions",
  confirmDelete: "Are you sure you want to delete this product?",
  visibility: "Visibility",
  hideProduct: "Hide product from store",
  showProduct: "Show product in store",
  prevPage: "Prev",
  nextPage: "Next",
  pageOf: "Page",
  productImage: "Product Image",
  productImages: "Product Images",
  uploadImage: "Upload Image",
  addImages: "Add Images",
  uploading: "Uploading...",
  or: "or",
  imageUrlPlaceholder: "Paste image URL and press Enter...",
  pressEnterToAdd: "Press Enter to add",
  dragToReorder: "Drag to reorder. First image is the main product image.",
  mainImage: "Main",
  invalidImageType: "Invalid file type. Please upload JPG, PNG, WebP or GIF.",
  imageTooLarge: "Image too large. Maximum size is 10MB.",
  searchProducts: "Search products...",
  allCategories: "All Categories",
  visibleOnly: "Visible Only",
  hiddenOnly: "Hidden Only",
  sortAZ: "Name A-Z",
  sortZA: "Name Z-A",
  sortPriceLow: "Price: Low to High",
  sortPriceHigh: "Price: High to Low",
  sortBestSellers: "Best Sellers",
  sortNewest: "Newest First",
  clearFilters: "Clear Filters",

  // Checkout Success
  processingPaymentTitle: "Processing Payment",
  processingPaymentMsg: "Please wait while we confirm your payment...",
  paymentSuccessful: "Payment Successful!",
  thankYou: "Thank you for your order. You will receive a confirmation email shortly.",
  totalPaid: "Total Paid:",
  viewOrders: "View Orders",
  sessionExpired: "Session Expired",
  sessionExpiredMsg: "Your payment session has expired. Please try again.",
  returnToCart: "Return to Cart",
  somethingWentWrong: "Something Went Wrong",
  paymentVerifyFailed: "We couldn't verify your payment. If you were charged, please contact support.",
  paymentProcessingTitle: "Payment Processing",
  paymentProcessingMsg: "Your payment is still being processed. Please check your email for confirmation or contact support.",
  returnToHome: "Return to Home",

  // Footer
  footerAbout: "Your destination for authentic luxury fragrances from the world's most prestigious brands.",
  footerShop: "SHOP",
  footerInfo: "INFORMATION",
  footerAccount: "ACCOUNT",
  signInFooter: "Sign In",
  shoppingCartFooter: "Shopping Cart",
  footerHelp: "Help",
  footerLegal: "Legal",
  faq: "FAQ",
  shippingReturns: "Shipping & Returns",
  aboutUs: "About Us",
  allRightsReserved: "All rights reserved.",

  // About Us
  aboutTitle: "ABOUT KOSTIN",
  aboutSubtitle: "Selection of luxury fragrances",
  aboutIntro1: "KOSTIN is a premium online destination for authentic luxury fragrances from globally recognized perfume houses and designer brands.",
  aboutIntro2: "We are founded on one essential principle \u2014 <strong>uncompromising authenticity</strong>. In an industry where trust defines quality, KOSTIN is committed to offering only original perfumes sourced from established, world-renowned brands. Every fragrance available in our store reflects the highest standards of craftsmanship, elegance, and reliability.",
  aboutAuth: "Authenticity",
  aboutAuthDesc: "100% genuine fragrances sourced through established distribution channels",
  aboutQuality: "Quality",
  aboutQualityDesc: "Only premium perfume brands that meet our strict quality standards",
  aboutTrust: "Trust",
  aboutTrustDesc: "Building lasting relationships through transparency and reliability",
  aboutCollectionTitle: "Our Curated Collection",
  aboutCollectionText: "Our curated portfolio includes luxury fragrances for men and women, designed for individuals who value certified quality, brand heritage, and premium self-expression. From timeless classics to modern masterpieces, KOSTIN ensures that every perfume you receive is 100% genuine and carefully selected.",
  aboutFeature1: "Luxury men's fragrances",
  aboutFeature2: "Elegant women's perfumes",
  aboutFeature3: "Exclusive niche brands",
  aboutFeature4: "Certified authentic products",
  aboutPhilosophyTitle: "Our Philosophy",
  aboutPhilosophy1: "At KOSTIN, luxury is defined by <strong>trust, authenticity, and consistency</strong>. We believe that true confidence begins with wearing a fragrance that is not only captivating, but also verified in origin and reputation.",
  aboutPhilosophy2: "By providing access to original, branded perfumes online, we aim to make premium fragrances more accessible, secure, and convenient \u2014 without compromising on quality or authenticity.",
  aboutMission1: "KOSTIN is more than an online beauty store.",
  aboutMission2: "It is a trusted source for luxury skincare, branded cosmetics, and original perfumes.",
  aboutMissionTagline: "Because true luxury begins with authenticity.",
  discoverCollection: "Discover our collection of luxury fragrances",
  aboutDiscoverTitle: "Discover Our Collection",
  aboutDiscoverText: "Explore our curated selection of authentic luxury beauty products",
  shopNow: "Shop Now",
  readMore: "Read more",
  showLess: "Show less",

  // About - Extended sections (SEO expansion)
  aboutStoryTitle: "The Story of KOSTIN",
  aboutStoryText1: "KOSTIN was born from a belief that true luxury fragrances deserve more than the shelves of anonymous online marketplaces. As passionate collectors ourselves, we noticed a significant gap in the market — original designer perfumes were often difficult to source in Bulgaria, and low-cost alternatives left much to be desired in terms of authenticity.",
  aboutStoryText2: "We founded KOSTIN to change that. We built a network of European distributors with direct ties to perfumery houses such as Christian Dior, Chanel, Yves Saint Laurent, Guerlain, Tom Ford, Creed, Giorgio Armani, and dozens more. Today, every bottle we ship carries the story of its origin — from the factory to your door, with no intermediate risk.",
  aboutStoryText3: "We understand that a perfume is not just a product — it is an extension of one's personality, a memory that others will associate with you for years to come. That is why we commit to offering only fragrances we would proudly wear ourselves.",

  aboutAuthTitle: "The Journey of Every Perfume",
  aboutAuthText1: "Every perfume in our collection passes through a four-step verification process before reaching you. First, we source our products through established distribution channels — never unverified sources.",
  aboutAuthText2: "Second, at KOSTIN we sell only original products, sourced through established distribution channels. Customers can additionally use the batch code found on each bottle to check available production information through independent services such as CheckFresh or CheckCosmetic.",
  aboutAuthText3: "Third, we inspect the packaging — cellophane integrity, box embossing, print quality, and unique serial numbers. And fourth, the scent itself is compared against our team's expert references.",
  aboutAuthText4: "We encourage you to verify as well — on the bottom of every bottle you will find a batch code you can validate yourself. Transparency is the foundation of our relationship with you.",

  aboutDeliveryTitle: "Delivery Across Bulgaria",
  aboutDeliveryText1: "We work exclusively with Speedy — the most reliable courier in Bulgaria. Every order is tracked from dispatch to delivery. If you prefer office pickup, you can choose from over 550 Speedy offices across the country.",
  aboutDeliveryText2: "Orders are processed within 1–2 business days. Delivery time may vary depending on the courier and destination. Free shipping is available for orders over €90.",
  aboutDeliveryText3: "Every order is insured during transit. If you experience any issues receiving your package or it arrives damaged, contact us within 48 hours — we will arrange a replacement or full refund without unnecessary questions.",
  aboutDeliveryText4: "For additional peace of mind, every order comes with a free Speedy return voucher valid for 14 days — a legal right under Bulgarian consumer protection law that we honor without exception.",

  aboutGuideTitle: "How to Choose the Right Fragrance",
  aboutGuideText1: "Choosing a perfume is a personal and often emotional experience. The first step is understanding the main fragrance families: citrus (fresh, energizing), floral (delicate, romantic), woody (warm, distinctive), oriental (rich, sensual), fougère (green, classically masculine), and ambro-musky (intimate, long-lasting).",
  aboutGuideText2: "The second step is context — lighter, fresher scents suit the office; warm and oriental scents suit romantic evenings; clean, aquatic scents suit sports; concentrated EDPs or Parfums suit special occasions. Seasonality also matters: summer fragrances should be light and fresh; winter fragrances warm and enveloping.",
  aboutGuideText3: "On our site every product features a detailed fragrance pyramid (top, heart, base notes) and scent profile tags — you can filter the collection by notes you love: vanilla, citrus, leather, tobacco, woody, floral, and 10+ more categories. If you are new to luxury fragrances, start with proven favorites like Dior Sauvage, Chanel Bleu de Chanel, YSL Black Opium, or La Vie Est Belle — they are trusted by millions and rarely disappoint.",
  aboutGuideText4: "And remember: a true perfume reveals itself over time. Give it 30 minutes on the skin before judging — the base notes, which are most characteristic of the scent, develop after about half an hour.",

  // Shipping & Returns
  shippingTitle: "SHIPPING & RETURNS",
  shippingSubtitle: "We want you to love your purchase. Here's everything you need to know about our shipping and return policies.",
  shippingInfoTitle: "Shipping Information",
  processingTime: "Processing Time",
  processingTimeText: "Orders are processed within 1-2 business days (Monday-Friday, excluding holidays). You will receive a confirmation email with tracking information once your order ships.",
  shippingOptions: "Shipping Options",
  standardShipping: "Office Delivery",
  standardShippingPrice: "Price calculated by Speedy at checkout",
  expressShipping: "Address Delivery",
  expressShippingPrice: "Price calculated by Speedy at checkout",
  freeShippingOption: "Free Shipping",
  freeShippingOptionDesc: "On orders over \u20ac90",
  europeanShipping: "European Shipping",
  europeanShippingText: "We currently ship to all countries within Europe. Delivery times may vary depending on your location. All prices are in Euros (\u20ac) and include VAT where applicable.",
  trackingTitle: "Tracking Your Order",
  trackingText: "Once your order ships, you will receive a tracking number via email. You can track your package using this number on the carrier's website.",
  returnsTitle: "Returns Policy",
  returnWindow: "14-Day Return Window",
  returnWindowText: "We accept returns within 14 days of delivery. Products must be unopened, unused, and in their original packaging with all tags and labels attached.",
  returnProcess: "Return Process",
  returnStep1: "Contact our customer service team at <a>contact@kostinparfums.com</a> to initiate a return",
  returnStep2: "Receive your return authorization and prepaid shipping label",
  returnStep3: "Pack your items securely in the original packaging",
  returnStep4: "Attach the prepaid label and drop off at any authorized carrier location",
  returnStep5: "Receive your refund within 5-7 business days after we receive your return",
  nonReturnable: "Non-Returnable Items",
  nonReturn1: "Opened or used cosmetics and fragrances (for hygiene reasons)",
  nonReturn2: "Gift cards",
  nonReturn3: "Sale or clearance items marked as final sale",
  nonReturn4: "Products without original packaging or labels",
  exchanges: "Exchanges",
  exchangesText: "We currently do not offer direct exchanges. If you need a different product, please return the original item for a refund and place a new order.",
  damagedProducts: "Damaged or Defective Products",
  damagedText: "If you receive a damaged or defective product, please contact us within 7 days of delivery with photos of the item and packaging. We will provide a full refund or replacement immediately at no additional cost.",
  refundMethod: "Refund Method",
  refundText: "Refunds will be issued to your original payment method. Please allow 5-7 business days for the refund to appear in your account after we process your return.",
  needHelp: "Need Help?",
  needHelpText: "Our customer service team is available Monday-Friday, 9AM-6PM CET.",

  // FAQ
  faqTitle: "FREQUENTLY ASKED QUESTIONS",
  faqSubtitle: "Find answers to common questions about our products, shipping, and policies.",
  faqQ1: "Are all your products authentic?",
  faqA1: "Yes, 100% of our products are authentic and sourced directly from authorized distributors and trusted suppliers. We guarantee the authenticity of every item we sell.",
  faqQ2: "How long does shipping take?",
  faqA2: "Orders are processed within 1-2 business days. Delivery time may vary depending on the courier and destination. Free shipping is available on orders over \u20ac90.",
  faqQ3: "What is your return policy?",
  faqA3: "We accept returns within 14 days of delivery for unopened products in their original packaging. The item must be unused and in the same condition that you received it. Please see our Shipping & Returns page for complete details.",
  faqQ4: "Do you ship internationally?",
  faqA4: "Currently, we ship within Europe only. We are working on expanding our shipping options to other regions in the near future.",
  faqQ5: "How can I track my order?",
  faqA5: "Once your order ships, you will receive a confirmation email with a tracking number. You can use this number to track your package on the carrier's website.",
  faqQ6: "What payment methods do you accept?",
  faqA6: "We accept all major credit cards (Visa, Mastercard, American Express), PayPal, and Apple Pay. All transactions are secured with industry-standard encryption.",
  faqQ7: "Can I cancel or modify my order?",
  faqA7: "Orders can be cancelled or modified within 24 hours of placement. Please contact us immediately at contact@kostinparfums.com if you need to make changes to your order.",
  faqQ8: "What if I receive a damaged or defective product?",
  faqA8: "If you receive a damaged or defective product, please contact us within 7 days of delivery with photos of the item. We will provide a full refund or replacement immediately.",
  faqQ9: "Do you have a loyalty program?",
  faqA9: "Yes! Our loyalty program rewards customers with points on every purchase. Points can be redeemed for discounts on future orders. Sign up for an account to start earning rewards.",
  faqQ10: "How should I store my cosmetics and fragrances?",
  faqA10: "Store your products in a cool, dry place away from direct sunlight. Fragrances should be kept in their original packaging to preserve their quality. Avoid storing products in bathrooms where humidity can affect their integrity.",
  faqQ11: "What is the difference between EDT, EDP, and Parfum?",
  faqA11: "The difference lies in the concentration of aromatic oils. Eau de Toilette (EDT) contains 5–15% and lasts 3–5 hours — ideal for daily wear and warmer months. Eau de Parfum (EDP) contains 15–20% oils and lasts 6–8 hours — the most balanced choice. Parfum (Extrait) is the most concentrated (20–40%) and can last over 10 hours — a luxurious choice for special occasions.",
  faqQ12: "How do I know which fragrance suits me?",
  faqA12: "First, think about your mood and the occasion. For the office and weekdays, choose fresh, citrus, or soft floral scents. For evening — warmer, oriental, woody, or musky. If you are a beginner, start with popular bestsellers (Dior Sauvage, Chanel Bleu, YSL Libre, La Vie Est Belle) — they are a safe choice. Use the site's Scent Profile filter to discover fragrances by notes you enjoy.",
  faqQ13: "How long does a perfume last on skin?",
  faqA13: "Longevity depends on concentration (EDT vs EDP vs Parfum), skin type (dry skin holds fragrance less), season (cold weather reduces diffusion), and where you apply — pulse points (wrists, neck, behind the ears) activate the scent through body heat. Moisturized skin retains fragrance 30–50% longer.",
  faqQ14: "Can I sample a fragrance before buying?",
  faqA14: "We do not yet offer test samples online, but we are working on it. In the meantime, we recommend reading the detailed description with the fragrance pyramid for each product — you will find top, middle, and base notes that give a clear idea of the scent.",
  faqQ15: "Can I verify the authenticity of a perfume after receiving it?",
  faqA15: "Every authentic perfume has a batch code — usually on the bottom of the bottle and on the box. You can use it to check available production information through independent services such as CheckFresh or CheckCosmetic. At KOSTIN, we sell only original products, sourced through established distribution channels.",
  faqQ16: "Is Cash on Delivery (COD) available?",
  faqA16: "Yes, we support Cash on Delivery via Speedy across the entire territory of Bulgaria. When you select COD, you pay directly to the courier upon receipt. No additional fees. No minimum order amount.",
  faqQ17: "Do you issue business invoices?",
  faqA17: "Yes. On the checkout page you can enter company details (company name, VAT/EIK number, MOL, registered address). The invoice is generated automatically via Inv.bg and sent to your email along with the order confirmation.",
  faqQ18: "How do promo codes work and where do I enter them?",
  faqA18: "On the checkout page there is a \"Promo code\" field — enter the code and click \"Apply\". The discount is reflected immediately in the total. One code can be used once per order. Codes cannot be combined with other ongoing discounts.",
  faqQ19: "Can I change the delivery address after placing the order?",
  faqA19: "Yes, if the order has not yet been handed to the courier. Contact contact@kostinparfums.com within 4 hours of placing your order with the new address. After shipping, the change is made directly through Speedy using the tracking number.",
  faqQ20: "What is the 14-day free return voucher?",
  faqA20: "Every order comes with a free Speedy return voucher valid for 14 days, in accordance with Bulgarian legislation. The product must be in original, unopened packaging. Full details on the Shipping & Returns page.",
  faqQ21: "How do I layer two fragrances?",
  faqA21: "Layering is a technique for creating a unique scent. Rule: start with the heavier/denser fragrance on the bottom, then add the lighter (fresher) one on top. Combine complementary families — e.g., vanilla + citrus, woody + floral. Apply one first, wait 30 seconds, then the other.",
  faqQ22: "Which fragrances suit different seasons?",
  faqA22: "Summer: citrus, aquatic, fresh, green scents (Acqua di Gio, Light Blue). Autumn: warm woody, leather, tobacco (Tom Ford Tobacco Vanille). Winter: oriental, vanilla, gourmand (Black Opium, Aventus). Spring: floral, fruity, fresh florals (Miss Dior, J'adore). Summer days call for lighter EDTs; winter — more concentrated EDPs or Extraits.",
  faqQ23: "Do you offer gift wrapping or bulk orders?",
  faqA23: "Yes. For gift orders we can include a handwritten card (free of charge) — just mention it in the notes at checkout. For orders over €500 we offer personalized service and potential discounts — contact contact@kostinparfums.com for a quote.",
  faqQ24: "What is the difference between designer and Dubai fragrances?",
  faqA24: "Original designer perfumes (Chanel, Dior, YSL) are produced in controlled European and American factories with strict standards. Dubai fragrances (our separate collection) are exclusive Arabic interpretations of popular scents, produced in the United Arab Emirates — ideal for collectors seeking new olfactory horizons. Both categories we sell are 100% authentic.",
  faqQ25: "Is my personal information secure?",
  faqA25: "Absolutely. We use SSL encryption across the entire site, Stripe for payments (PCI-DSS certified, we do not store card data on our servers), and comply with GDPR for personal data processing. You can review our Privacy Policy for full details.",
  faqStillQuestions: "Still have questions?",
  faqContact: "Our customer service team is here to help. Contact us at",

  // Common
  loading: "Loading...",
  error: "Something went wrong",
  curatedBeautyEssentials: "SELECTION OF LUXURY FRAGRANCES",
  
  // Homepage Management
  homepageTab: "Homepage",
  heroSlides: "Hero Carousel Images",
  addImage: "Add Image",
  saveChanges: "Save Changes",
  savedSuccessfully: "Saved successfully!",
  saving: "Saving...",
  uploading: "Uploading...",
  featuredProducts: "Featured Products",
  featuredProductsDesc: "Select products to display in the 'New Arrivals' section on the homepage.",
  selectedProducts: "Selected Products",
  availableProducts: "Available Products",
  searchProducts: "Search products...",

  // Legal Info
  legalInfo: "Legal Information",
  companyName: "Company",
  companyEik: "Registration No.",
  companyAddress: "Address",
  companyManager: "Manager",
  companyActivity: "Activity",
  companyActivityDesc: "Retail trade in perfumery and cosmetic products (NACE 47.75)",
  fullLegalInfo: "Full Legal Information",

  // Email Verification
  verifyingEmail: "Verifying email...",
  pleaseWait: "Please wait...",
  emailVerifiedTitle: "Email Verified!",
  emailVerified: "Your email address has been successfully verified.",
  verificationFailedTitle: "Verification Failed",
  verificationFailed: "The link is invalid or has expired.",
  verificationError: "An error occurred. Please try again.",
  invalidVerificationLink: "Invalid verification link.",
  loginNow: "LOG IN NOW",
  tryAgain: "TRY AGAIN",

  // Order Verification
  verifyingOrder: "Verifying order...",
  orderConfirmedTitle: "Order Confirmed!",
  orderVerified: "Your order has been successfully confirmed.",
  orderVerificationFailedTitle: "Verification Failed",
  orderVerificationFailed: "The link is invalid or has expired.",
  orderNumber: "Order Number",
  orderConfirmationSent: "You will receive an email with final confirmation and shipping information.",
  viewOrders: "MY ORDERS",
  continueShopping: "CONTINUE SHOPPING",
  contactSupport: "Contact us",
  backToHome: "BACK TO HOME",

  // Registration messages
  checkEmailToVerify: "Please check your email to verify your registration.",
  verifyEmailFirst: "Please verify your email first. We have sent a new verification link.",

  // Recently Viewed
  recentlyViewed: "RECENTLY VIEWED",

  // Checkout Page
  checkout: "Checkout",
  backToCart: "Back to cart",
  shippingMethod: "Shipping Method",
  speedyOfficeDesc: "Pick up from the nearest Speedy office",
  addressDeliveryDesc: "Delivery directly to your address",
  speedyOfficeAddress: "Details for office pickup",
  speedyOfficeNote: "Enter contact details. You will receive SMS with office information upon dispatch.",
  contactInfo: "Contact Information",
  paymentMethod: "Payment Method",
  payWithCard: "Pay with Card",
  cardSecure: "Secure payment via Stripe",
  cashOnDelivery: "Cash on Delivery",
  codDesc: "Pay when you receive your order",
  deliveryAddress: "Delivery Address",
  fullName: "Full Name",
  phone: "Phone",
  address: "Address",
  city: "City",
  postalCode: "Postal Code",
  deliveryNotes: "Delivery Notes",
  deliveryNotesPlaceholder: "Additional instructions for the courier...",
  requiredField: "Required field",
  payNow: "Pay Now",
  placeOrder: "Place Order",
  processing: "Processing...",
  secureStripe: "Secure payment via Stripe",
  orderConfirmed: "Order Confirmed!",
  orderNumber: "Order Number",
  orderSummary: "Order Summary",
  subtotal: "Subtotal",
  shipping: "Shipping",
  total: "Total",
  continueShopping: "Continue Shopping",
  viewOrders: "View Orders",
  codSuccessMessage: "Thank you for your order! You will receive a confirmation email. Payment will be collected upon delivery.",
  totalToPay: "Amount to pay on delivery",
  freeReturn: "Free returns within 14 days",
  freeReturnDesc: "For unopened products",
  free: "Free",
  manageCollections: "Manage Collections",
  collectionsDescription: "Create collections to organize products into pages and campaigns.",
  createNewCollection: "Create New Collection",
  collectionName: "Name (BG)",
  collectionNameEn: "Name (EN)",
  collectionSlug: "Slug (URL)",
  collectionDescription: "Description (BG)",
  collectionDescriptionEn: "Description (EN)",
  collectionBanner: "Banner image (collection page)",
  uploadBanner: "Upload banner",
  creating: "Creating...",
  createCollection: "Create Collection",
  showInNav: "Show in navigation (header/footer)",
  noCollections: "No collections created",
  confirmDeleteCollection: "Are you sure you want to delete this collection?",
  type: "Type",
  inNav: "In Nav",
  status: "Status",
  system: "System",
  custom: "Custom",
  active: "Active",
  inactive: "Inactive",
  brandBackgrounds: "Backgrounds",
  variantsTab: "Variants",

  notFoundCode: "404",
  notFoundTitle: "This fragrance has evaporated...",
  notFoundMessage: "The page you're looking for doesn't exist or has been moved. But our collection of luxury perfumes is definitely waiting for you.",
  notFoundHomeBtn: "Back to Home",
  notFoundShopBtn: "Shop All Products",
};
